module.exports = __webpack_public_path__ + "media/images/ui__infoBoxSmall--dark-6154f6245f2a3c47863ca849fff21fc2.png";